<template>
  <div class="vue3-slot">
    <!-- Default slot -->
    <h2><slot name="header" v-if="$slots.header">Заголовок слота</slot></h2>
    
    <!-- Main/default content -->
    <slot name="problem" v-if="$slots.problem">Проблематика слота</slot>
    
    <!-- Footer slot -->
    <slot name="default" v-if="$slots.default">Перешние проблемы</slot>
  </div>
</template>

<script>
export default {
  name: 'Vue3Syntax',
};
</script>

<style scoped>
.vue3-slot {
  padding: 20px;
  background: #f7f9fa;
  border-radius: 8px;
  border: 1px solid #5a5a5a;
  margin:20px;
}

.vue3-slot :deep(h2) {
  margin-top: 0;
  color: #35495e;
}

.vue3-slot :deep(p) {
  margin: 0;
  color: #555;
}
</style>
